<template>
  <div v-if="show && show.type == TYPE_PAID" class="tickets-container">
    <div
        v-for="price in showPrices"
        :key="`price_${price.id}`"
        :class="showPriceId === price.id ? 'tickets selected' : 'tickets'"
    >
      <p>
        {{ price.name }} <strong>${{ price.priceIncludesPlatformFee ? price.price + price.platformFee : price.price }}</strong>
        <span>+ ${{ price.priceIncludesPlatformFee ? 0 : price.platformFee }} costo de servicio</span>
      </p>

      <div v-if="!isAvailable(price) || !isReservable(price)" class="ticket-status soldout">
        <p><strong>&emsp;{{ !isReservable(price) ? $t('notReservable') : $t('show.soldout') }}</strong></p>
      </div>
      <div v-if="isAvailable(price) && isReservable(price)" class="field">
        <label class="radio">
          <input
              v-model="showPriceId"
              type="radio"
              name="radio"
              :value="price.id"
              @click="selectPrice(price)"
          >
          <i class="fa fa-check"/>
        </label>
      </div>
      <ticket-quantity-box
          v-if="showPriceId === price.id && !price.soldOut"
          :ticket-quantity="quantityPreference ?? ticketQuantity"
          :ticket-limit="price.maxTicketsPerReservation"
          @quantity-change="(newQuantity) => ticketQuantity = newQuantity"
      />

      <div v-if="price.description" class="ticket-description">
        <i class="fa-solid fa-circle-info description-icon"/>
        <span class="description-text">{{ price.description }}</span>
      </div>

      <h4 v-if="price.reservableUntil && isReservable(price)" class="price-ends">
        {{$t('priceEnds')}}
        <NuxtTime
            class="capitalize"
            :datetime="price.reservableUntil"
            weekday="long"
            day="numeric"
            hour="numeric"
            minute="numeric"
            locale="es"
        />
        hs.
      </h4>
    </div>
  </div>
</template>
<script lang="ts">
import TicketQuantityBox from './TicketQuantityBox.vue'
import {defineComponent, type PropType} from 'vue'
import {TYPE_PAID} from '~/utils/definitions'
import type {ShowEventPublicOutput, ShowPricePublicOutput, ShowPublicOutput} from "~/api/generated";

export default defineComponent({
  components: {TicketQuantityBox},
  props: {
    showEvent: Object as PropType<ShowEventPublicOutput>,
    show: Object as PropType<ShowPublicOutput>,
    quantityPreference: Number,
    showPriceIdPreference: Number,
    enableSelectPrice: Boolean,
  },
  emits: ['onUpdatePriceId', 'onUpdateQuantity', 'onUpdateTotal'],
  data() {
    return {
      TYPE_PAID,
      total: 0,
      showPriceId: undefined,
      showPriceValue: 0,
      ticketQuantity: 0,
      showPrices: [] as ShowPricePublicOutput[],
    }
  },
  watch: {
    showPriceId(newValue) {
      this.$emit('onUpdatePriceId', newValue)
    },
    ticketQuantity() {
      this.total = this.ticketQuantity * this.showPriceValue
      this.$emit('onUpdateQuantity', this.ticketQuantity)
    },
    total(newValue) {
      this.$emit('onUpdateTotal', newValue)
    }
  },
  mounted() {
    this.showPriceId = this.showPriceIdPreference ?? undefined
    if (this.showPriceId !== undefined) {
      const showPrice = this.showEvent?.showPrices?.filter(
          (price) => price.id === this.showPriceId
      )
      const p = showPrice[0]
      this.showPriceValue = p ? (p.priceIncludesPlatformFee ? p.price + (p.platformFee ?? 0) : p.price) : 0
    }
    this.ticketQuantity = this.quantityPreference ?? 0
    this.total = this.ticketQuantity * this.showPriceValue
    // eslint-disable-next-line
    this.showPrices = this.showEvent?.showPrices?.sort(
        (a, b) => {
          if (a.soldOut === b.soldOut) {
            return a.price - b.price;
          }
          return a.soldOut ? 1 : -1;
        }
    )
  },
  methods: {
    selectPrice(price: ShowPricePublicOutput) {
      this.showPriceValue = price.priceIncludesPlatformFee ? price.price + (price.platformFee ?? 0) : price.price;
      this.total = this.ticketQuantity * this.showPriceValue
      this.ticketQuantity
    },
    isAvailable(price: ShowPricePublicOutput): boolean {
      return !price.soldOut && true;
    },
    isReservable(price: ShowPricePublicOutput): boolean {
      if (price.reservableUntil === null || price.reservableUntil === undefined) {
        return true;
      }
      return new Date(price.reservableUntil).toISOString() >= new Date().toISOString();
    }
  },
})
</script>
<style scoped>
.ticket-description {
  clear: both;
  margin-top: 0.6rem;
  margin-bottom: 0.25rem;
  padding: 0.5rem 0.75rem;
  background: rgba(255, 255, 255, 0.03);
  border-left: 3px solid #00c1ff;
  border-radius: 0 0.375rem 0.375rem 0;
  font-size: 0.85rem;
  line-height: 1.4;
  color: #cbd5e1;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  word-break: break-word;
  white-space: pre-line;
  text-transform: none;
  transition: all 0.25s ease;
}

.tickets.selected .ticket-description {
  border-left-color: #ff96c9;
  background: rgba(255, 150, 201, 0.06);
  color: #f1f5f9;
}

.description-icon {
  color: #00c1ff;
  font-size: 0.85rem;
  margin-top: 0.15rem;
  flex-shrink: 0;
  transition: color 0.25s ease;
}

.tickets.selected .description-icon {
  color: #ff96c9;
}

.description-text {
  flex: 1;
  text-transform: none;
  letter-spacing: 0.01em;
}

.price-ends {
  clear: both;
  margin-top: 0.25rem;
}
</style>
